import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./header.css";
import { Dropdown, DropdownButton } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Faqcontainer from "../Faqcontainer";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
  faCaretDown,
  faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import { useCourses } from "../Contexts/CoursesContext";
import { useEnrollee } from "../Contexts/EnrolleeContext";
import { useUsers } from "../Contexts/UsersContext";
import { PopulateContext } from "../../App";
import { checkIfInDecember } from "../../App";
// import {InstantSearch, Pagination} from 'react-instantsearch';
import { Search, X } from "lucide-react";

interface Course {
  inverse: boolean;
  Category: string;
  Duration: string;
  Color: string;
  CourseColor: string;
  CourseImage: string;
  CourseName: string;
  id: string;
  Price: number;
  isArchive: boolean;
}

const Header: React.FC = () => {
  let navigate = useNavigate();
  const { Enrollee, setEnrolleeContext } = useEnrollee();
  const { User, Users, setUserContext, setUsersContext } = useUsers();
  const { courses, setCoursesContext } = useCourses();

  const [authUser, setAuthUser] = useState(false);
  const [usersAvatar, setUsersAvatar] = useState("");
  const [showcatalogbox, setShowcatalogbox] = useState(false);
  const [showcatalogboxSecond, setShowcatalogboxSecond] = useState(false);
  const [showcatalogboxThird, setShowcatalogboxThird] = useState(false);
  const [fullnames, setFullnames] = useState("");
  const [fullnameprefix, setFullnameprefix] = useState("");
  const [showcoursesbox, setShowcoursesbox] = useState(false);
  const [showcoursesboxSide, setShowcoursesboxSide] = useState(false);
  const [showServicesBox] = useState(false);
  const [filteredCourses, setFilteredCourses] = useState<Course[]>([]);
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [isVisibler, setIsVisibler] = useState(true);
  const [showSearch, setShowsearch] = useState(false);
  const [activeDropdownId, setActiveDropdownId] = useState<string | null>(null);
  const { weAreInDecember } = checkIfInDecember();
  const searchRef = useRef<HTMLDivElement | null>(null);
  const profileRef = useRef<HTMLDivElement | null>(null);
  const profileRefSecond = useRef<HTMLDivElement | null>(null);
  const profileRefThird = useRef<HTMLDivElement | null>(null);

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);

  useEffect(() => {
    document.body.style.overflow = sidebarOpen ? "hidden" : "auto";
  }, [sidebarOpen]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const isVisibler =
        prevScrollPos > currentScrollPos || currentScrollPos === 0;
      setPrevScrollPos(currentScrollPos);
      setIsVisibler(isVisibler);
    };
    window.addEventListener(`scroll`, handleScroll);

    return () => {
      window.removeEventListener(`scroll`, handleScroll);
    };
  }, [prevScrollPos]);

  const handleShowSearch = () => {
    setShowsearch(true);
  };

  const handleCloseSearch = () => {
    setShowsearch(false);
  };

  const toWebinar = () => {
    navigate("/webinars");
  };
  const toSignin = () => {
    navigate("/signin");
  };

  const toSignUp = () => {
    navigate("/signup");
  };

  const showCousesList = () => {
    setShowcoursesbox(!showcoursesbox);
  };
  const toYungDoyen = () => {
    window.open("https://yung.doyenify.com", "_blank");
  };

  const toProfile = () => {
    navigate("/profile");
  };

  const userSignOut = () => {
    signOut(auth)
      .then(() => {
        setUserContext(null);
        setEnrolleeContext(null);
        localStorage.removeItem("UserId");
        navigate("/signin", { state: { from: "/" } });
        setAuthUser(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const toDoyenifyJobs = () => {
    window.open("https://jobs.doyenify.com", "_blank");
  };

  useEffect(() => {
    const populateUsers = async () => {
      const UserId = localStorage.getItem("UserId");
      if (UserId && UserId?.length > 0) {
        if (!courses) {
          const Courses = await PopulateContext("Courses");
          if (Courses) {
            let filteredCourses = Courses.filter(
              (course: any) => !course.isArchive && course.isDeleted === false,
            );
            setCoursesContext(filteredCourses);
          }
        }
        if (!User) {
          setAuthUser(false);
          const user = await PopulateContext("User");
          setUserContext(user);
        } else {
          const userEmail = User?.email || "";
          const userEmailLength = userEmail.length;
          setUsersAvatar(
            userEmailLength > 18 ? `${userEmail.slice(0, 18)}...` : userEmail,
          );
          setFullnames(User?.firstname + " " + User?.lastname);
          setFullnameprefix(
            (User?.firstname.slice(0, 1) || "") +
              (User?.lastname.slice(0, 1) || ""),
          );
          setAuthUser(true);
        }
        if (!Users) {
          const users = await PopulateContext("Users");
          setUsersContext(users);
        }
        if (!Enrollee) {
          const Enrollees = await PopulateContext("Enrollees");
          setEnrolleeContext(Enrollees);
        }
      } else {
        setAuthUser(false);
        if (!courses) {
          const Courses = await PopulateContext("Courses");
          let filteredCourses = Courses.filter(
            (course: any) => !course.isArchive && course.isDeleted === false,
          );
          setCoursesContext(filteredCourses);
        }
      }
    };

    populateUsers();
  }, [
    Enrollee,
    User,
    Users,
    courses,
    setCoursesContext,
    setEnrolleeContext,
    setUserContext,
    setUsersContext,
  ]);

  const toGmailsite = () => {
    window.open(
      "https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=info.doyenify@gmail.com",
      "_blank",
    );
  };

  const toGmailsite2 = () => {
    window.open(
      "https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=info@doyenify.com",
      "_blank",
    );
  };

  const navigatehome = () => {
    navigate("/");
  };

  const toBlog = () => {
    navigate("/blogs");
  };
  const getajob = () => {
    navigate("/getajob");
  };

  const toHandsonexperience = () => {
    navigate("/handsonexperience");
  };
  const toInterviewprepcvreview = () => {
    window.open("https://aicvjobs.com/", "_blank");
  };
  const toBookConsultation = () => {
    navigate("/consult");
  };

  const toDoyenaccess = () => {
    navigate("/doyenaccess");
  };

  const toScholarship = () => {
    navigate("/scholarship");
  };

  const getCourseListDetails = (courseName: string) => {
    const slug = courseName
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
    navigate("/coursedetails/" + slug);
    showCousesList();
    // window.location.reload();
  };

  const showSoftwareCourses = () => {
    setFilteredCourses([]);
    const softwareCourses: any = courses?.filter(
      (course) => course.Category === "SoftwareEngineering",
    );
    setFilteredCourses(softwareCourses);
    setActiveDropdownId("softwareLink");
  };

  const showProductDesignCourses = () => {
    setFilteredCourses([]);
    const designCourses: any = courses?.filter(
      (course) => course.Category === "ProductDesign",
    );
    setFilteredCourses(designCourses);
  };

  const showDataScienceCourses = () => {
    setFilteredCourses([]);
    const dataCourses: any = courses?.filter(
      (course) => course.Category === "Data",
    );
    setFilteredCourses(dataCourses);
  };

  const showCyberSecurityCourses = () => {
    setFilteredCourses([]);
    const cyberCourses: any = courses?.filter(
      (course) => course.Category === "cybersecurity",
    );
    setFilteredCourses(cyberCourses);
  };

  const showProductManagementCourses = () => {
    setFilteredCourses([]);
    const productCourses: any = courses?.filter(
      (course) => course.Category === "ProductManagement",
    );
    setFilteredCourses(productCourses);
  };

  const showMarketingCourses = () => {
    setFilteredCourses([]);
    const marketingCourses: any = courses?.filter(
      (course) => course.Category === "Marketing",
    );
    setFilteredCourses(marketingCourses);
  };

  const showNocodepathCourses = () => {
    setFilteredCourses([]);
    const noCodeCourses: any = courses?.filter(
      (course) =>
        course.CourseName === "Graphics Design" ||
        course.CourseName === "WEB DESIGN" ||
        course.CourseName === "Search Engine Optimization" ||
        course.CourseName === "IT Business Analysis" ||
        course.CourseName === "Manual Software Testing" ||
        course.CourseName === "UI/UX DESIGN" ||
        course.CourseName === "Digital Marketing" ||
        course.CourseName === "Cyber Security" ||
        course.CourseName === "Product Management" ||
        course.CourseName === "Graphics Design" ||
        course.CourseName === "AI Fundamentals" ||
        course.CourseName === "Business Intelligence",
    );
    setFilteredCourses(noCodeCourses);
  };

  const ref = document.getElementById("coursse");
  const refprofile = document.getElementById("prrrofile");

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (ref && !ref.contains(event.target as Node)) {
        setShowcoursesbox(false);
      }
    }

    const handleClickOutsidesearch = (event: MouseEvent) => {
      if (
        searchRef.current &&
        !searchRef.current.contains(event.target as Node) // Click is outside search box
      ) {
        setShowsearch(false);
      }
    };

    if (showSearch) {
      document.addEventListener("mousedown", handleClickOutsidesearch);
    } else {
      document.removeEventListener("mousedown", handleClickOutsidesearch);
    }

    // function handleClickOutsideprofile(event: any) {
    //   if (refprofile && !refprofile.contains(event.target)) {
    //     setShowcatalogbox(false);
    //   }
    // }

    function handleClickOutsideprofile(event: any) {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowcatalogbox(false);
      }
    }

    function handleClickOutsideprofileSecond(event: any) {
      if (
        profileRefSecond.current &&
        !profileRefSecond.current.contains(event.target)
      ) {
        setShowcatalogboxSecond(false);
      }
    }

    function handleClickOutsideprofileThird(event: any) {
      if (
        profileRefThird.current &&
        !profileRefThird.current.contains(event.target)
      ) {
        setShowcatalogboxThird(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("mousedown", handleClickOutsideprofile);
    document.addEventListener("mousedown", handleClickOutsideprofileSecond);
    document.addEventListener("mousedown", handleClickOutsideprofileThird);

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("mousedown", handleClickOutsideprofile);
      document.removeEventListener("mousedown", handleClickOutsidesearch);
      document.addEventListener("mousedown", handleClickOutsideprofileSecond);
      document.addEventListener("mousedown", handleClickOutsideprofileThird);
    };
  }, [
    ref,
    refprofile,
    showcoursesbox,
    showcatalogbox,
    showServicesBox,
    showSearch,
    setShowcatalogboxSecond,
    setShowcatalogboxThird,
  ]);

  return (
    <div>
      <header className={"header"}>
        <Navbar
          collapseOnSelect
          expand="lg"
          style={{ backgroundColor: "#F2FFD8" }}
          variant="dark"
          className={
            isVisibler ? `header ${showSearch && "h-[70px] w-100"}` : "hidden"
          }
        >
          <div className="container-fluid">
            <div className="flex items-center sm:w-[100%]">
              <div className="flex items-center gap-2">
                <div className="xl:hidden lg:hidden flex items-center">
                  <button
                    className="p-2 text-[#367E3E]"
                    onClick={toggleSidebar}
                    aria-label="Toggle navigation"
                  >
                    <FontAwesomeIcon icon={faBars} size="lg" />
                  </button>
                </div>

                {/* ==== LEFT SECTION: LOGO + TOGGLER ( on mobile) ==== */}
                <div className="flex items-center gap-2">
                  <Navbar.Brand
                    onClick={navigatehome}
                    className="cursor-pointer"
                  >
                    <img
                      alt="doyenify academy logo"
                      src={
                        weAreInDecember
                          ? "../../images/new-logo.png"
                          : "../../images/doyenifyAcademy.png"
                      }
                      className="d-inline-block ms-0 ms-lg-5  align-top companylogo w-[100px] lg:w-[120px] xl:w-[140px] h-[38px] lg:h-[48px] xl:h-[48px]"
                    />
                  </Navbar.Brand>
                </div>
              </div>

              {/* ==== MOBILE SEARCH ICON ==== */}
              <div style={{ width: "50%" }}>
                <div
                  className="flex items-center justify-end gap-3 xl:hidden lg:hidden"
                  style={{ float: "right" }}
                >
                  {!showSearch && (
                    <div
                      onClick={handleShowSearch}
                      className="cursor-pointer text-[#367E3E]"
                    >
                      <FontAwesomeIcon icon={faMagnifyingGlass} size="lg" />
                    </div>
                  )}

                  {authUser && (
                    // <div
                    //   onClick={showCatalog}
                    //   className="cursor-pointer flex items-center justify-center w-[36px] h-[36px] rounded-full bg-[#156614]"
                    // >
                    //   <h5 className="text-white text-[20px] font-semibold">
                    //     {fullnameprefix}
                    //   </h5>
                    // </div>

                    <div
                      ref={profileRef}
                      id="prrrofile"
                      className="relative flex items-center justify-end"
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      {/* Profile Icon */}
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowcatalogbox((prev) => !prev);
                        }}
                        className="text-center cursor-pointer"
                        style={{
                          marginTop: "5px",
                          width: "40px",
                          height: "40px",
                          borderRadius: "100px",
                          backgroundColor: "#156614",
                          animation: "glow 1s infinite",
                        }}
                      >
                        <h5 style={{ color: "#ffffff", paddingTop: "30%" }}>
                          {fullnameprefix}
                        </h5>
                      </div>
                      {/* Dropdown Menu */}
                      {showcatalogbox && (
                        <div
                          className="absolute bg-[#e3f8e7] border border-[#95beb5] rounded-xl p-3 shadow-md z-50"
                          style={{
                            top: "120%",
                            right: "0",
                            width: "240px",
                            transition: "all 0.3s ease",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="text-center">
                            <div
                              className="mx-auto flex items-center justify-center mb-2"
                              style={{
                                width: "50px",
                                height: "50px",
                                borderRadius: "100px",
                                backgroundColor: "#156614",
                              }}
                            >
                              <h3 style={{ color: "#ffffff" }}>
                                {fullnameprefix}
                              </h3>
                            </div>
                            <p style={{ fontWeight: "bold", fontSize: "16px" }}>
                              {usersAvatar}
                            </p>
                            <p style={{ color: "#696969", fontSize: "13px" }}>
                              {fullnames}
                            </p>
                            <hr />
                          </div>

                          <div style={{ marginLeft: "15px" }}>
                            <p
                              className="nav-links"
                              onClick={toProfile}
                              style={{ cursor: "pointer" }}
                            >
                              My profile
                            </p>
                            <p
                              className="nav-links"
                              onClick={userSignOut}
                              style={{ cursor: "pointer" }}
                            >
                              Log out
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* ==== DESKTOP SEARCH BAR ==== */}
            {/* <div className="hidden lg:flex ml-10 w-[300px] xl:w-[380px]">
                  <SearchComponent />
                </div> */}

            {/* ==== NAV LINKS ==== */}
            {/* <button
                      className="block lg:hidden p-2 text-[#367E3E]"
                      onClick={toggleSidebar}
                      style={{ position: "absolute", top: "18px", left: "20px", zIndex: 40 }} 
                    >
                      <FontAwesomeIcon icon={faBars} size="lg" />
                    </button> */}

            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="justify-content-end flex-grow-1 pe-3">
                {/* {authUser ?  <></>: <> */}
                <div
                  onMouseEnter={() => setShowcoursesbox(true)}
                  onMouseLeave={() => setShowcoursesbox(false)}
                >
                  <div className="coursesNav" id="coursse">
                    <div
                      className="ms-5 text-black nav-links2"
                      onClick={showCousesList}
                      style={{
                        whiteSpace: "nowrap",
                      }}
                    >
                      Schools{" "}
                      <FontAwesomeIcon
                        className="socialmed2"
                        icon={faCaretDown}
                        style={{
                          marginLeft: "7px",
                          height: "12px",
                          display: "inline",
                          whiteSpace: "nowrap",
                        }}
                      />
                    </div>

                    <div
                      className={
                        showcoursesbox ? "showprofilebox" : "hideprofilebox"
                      }
                    >
                      <div className="coursescolorbox ">
                        <div>
                          <div className="container">
                            <div className="row coursetttab">
                              <div className="col-md-4">
                                <h4 style={{ color: "#597771" }}>Schools</h4>
                                <DropdownButton
                                  className="m-2 softwarelink"
                                  onClick={showSoftwareCourses}
                                  variant="default"
                                  id="dropdown-basic-button"
                                  title="Software Engineering"
                                  drop="end"
                                >
                                  {activeDropdownId === "softwareLink" &&
                                    filteredCourses?.length > 0 && (
                                      <div className="max-h-48 overflow-y-auto">
                                        {filteredCourses?.map((item) => (
                                          <Dropdown.Item
                                            key={item.id}
                                            onClick={() =>
                                              getCourseListDetails(
                                                item.CourseName,
                                              )
                                            }
                                          >
                                            {item.CourseName}
                                          </Dropdown.Item>
                                        ))}
                                      </div>
                                    )}
                                </DropdownButton>

                                <DropdownButton
                                  className="m-2 productdesignlink"
                                  onClick={showProductDesignCourses}
                                  variant="default"
                                  id="dropdown-basic-button"
                                  title="Product Design"
                                  drop="end"
                                >
                                  {filteredCourses?.length > 0 ? (
                                    <div className="max-h-48 overflow-y-auto">
                                      {filteredCourses?.map((item) => (
                                        <Dropdown.Item
                                          key={item.id}
                                          onClick={() =>
                                            getCourseListDetails(
                                              item.CourseName,
                                            )
                                          }
                                        >
                                          {item.CourseName}
                                        </Dropdown.Item>
                                      ))}
                                    </div>
                                  ) : null}
                                </DropdownButton>

                                <DropdownButton
                                  className="m-2 datasciencelink"
                                  onClick={showDataScienceCourses}
                                  variant="default"
                                  id="dropdown-basic-button"
                                  title="Data Science"
                                  drop="end"
                                >
                                  {filteredCourses?.length > 0 ? (
                                    <div className="max-h-48 overflow-y-auto">
                                      {filteredCourses?.map((item) => (
                                        <Dropdown.Item
                                          key={item.id}
                                          onClick={() =>
                                            getCourseListDetails(
                                              item.CourseName,
                                            )
                                          }
                                        >
                                          {item.CourseName}
                                        </Dropdown.Item>
                                      ))}
                                    </div>
                                  ) : null}
                                </DropdownButton>

                                <DropdownButton
                                  className="m-2 cybersecuritylink"
                                  onClick={showCyberSecurityCourses}
                                  variant="default"
                                  id="dropdown-basic-button"
                                  title="Cyber Security"
                                  drop="end"
                                >
                                  {filteredCourses?.length > 0 ? (
                                    <div className="max-h-48 overflow-y-auto">
                                      {filteredCourses?.map((item) => (
                                        <Dropdown.Item
                                          key={item.id}
                                          onClick={() =>
                                            getCourseListDetails(
                                              item.CourseName,
                                            )
                                          }
                                        >
                                          {item.CourseName}
                                        </Dropdown.Item>
                                      ))}
                                    </div>
                                  ) : null}
                                </DropdownButton>

                                <DropdownButton
                                  className="m-2 marketinglink"
                                  onClick={showMarketingCourses}
                                  variant="default"
                                  id="dropdown-basic-button"
                                  title="Marketing"
                                  drop="end"
                                >
                                  {filteredCourses?.length > 0 ? (
                                    <div className="max-h-48 overflow-y-auto">
                                      {filteredCourses?.map((item) => (
                                        <Dropdown.Item
                                          key={item.id}
                                          onClick={() =>
                                            getCourseListDetails(
                                              item.CourseName,
                                            )
                                          }
                                        >
                                          {item.CourseName}
                                        </Dropdown.Item>
                                      ))}
                                    </div>
                                  ) : null}
                                </DropdownButton>

                                <DropdownButton
                                  className="m-2 productmanagementlink"
                                  onClick={showProductManagementCourses}
                                  variant="default"
                                  id="dropdown-basic-button"
                                  title="Product Management"
                                  drop="end"
                                >
                                  {filteredCourses?.length > 0 ? (
                                    <div className="max-h-48 overflow-y-auto">
                                      {filteredCourses?.map((item) => (
                                        <Dropdown.Item
                                          key={item.id}
                                          onClick={() =>
                                            getCourseListDetails(
                                              item.CourseName,
                                            )
                                          }
                                        >
                                          {item.CourseName}
                                        </Dropdown.Item>
                                      ))}
                                    </div>
                                  ) : null}
                                </DropdownButton>

                                <DropdownButton
                                  className="m-2 nocodelink"
                                  onClick={showNocodepathCourses}
                                  variant="default"
                                  id="dropdown-basic-button"
                                  title="No Code Path"
                                  drop="end"
                                >
                                  {filteredCourses?.length > 0 ? (
                                    <div className="max-h-32 overflow-y-auto">
                                      {filteredCourses?.map((item) => (
                                        <Dropdown.Item
                                          key={item.id}
                                          onClick={() =>
                                            getCourseListDetails(
                                              item.CourseName,
                                            )
                                          }
                                        >
                                          {item.CourseName}
                                        </Dropdown.Item>
                                      ))}
                                    </div>
                                  ) : null}
                                </DropdownButton>
                              </div>
                              <div className="col-md-8">
                                <br />
                                <h4>Our services</h4>
                                <div
                                  className="row"
                                  style={{ marginTop: "15px" }}
                                >
                                  <div className="col-md-6">
                                    <p
                                      className="nav-links23"
                                      onClick={toYungDoyen}
                                    >
                                      Yung Doyens
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p
                                      className="nav-links23"
                                      onClick={toHandsonexperience}
                                    >
                                      Hands-on Experience
                                    </p>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-md-6">
                                    <p
                                      className="nav-links23"
                                      onClick={toInterviewprepcvreview}
                                    >
                                      Interview Prep/CV Review
                                    </p>
                                  </div>

                                  <div className="col-md-6">
                                    <p
                                      className="nav-links23"
                                      onClick={getajob}
                                    >
                                      Doyenify Talent
                                    </p>
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-md-6">
                                    <p
                                      className="nav-links23"
                                      onClick={toDoyenaccess}
                                    >
                                      Doyen Access
                                    </p>
                                  </div>

                                  <div className="col-md-6">
                                    <p
                                      className="nav-links23"
                                      onClick={toBookConsultation}
                                    >
                                      Where do I begin?
                                    </p>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <p
                                    className="nav-links23"
                                    onClick={toDoyenifyJobs}
                                  >
                                    Jobs
                                  </p>
                                </div>
                                <hr />
                                <div>
                                  <h4>Why learn at Doyenify Academy</h4>
                                  <p>
                                    We provide educational programs crafted by
                                    experts with deep industry knowledge and
                                    co-created with leading companies.
                                  </p>

                                  {authUser ? (
                                    <></>
                                  ) : (
                                    <div style={{ display: "inline" }}>
                                      <button
                                        className="btn joinforbtn"
                                        onClick={toSignUp}
                                      >
                                        Join for Free
                                      </button>
                                    </div>
                                  )}
                                </div>
                                <div style={{ marginTop: "11px" }}>
                                  <Faqcontainer />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <Nav.Link
                  href="#howitwork"
                  className="ms-5 text-black nav-links2"
                  onClick={navigatehome}
                  style={{ whiteSpace: "nowrap" }}
                >
                  How it works{" "}
                </Nav.Link>

                <NavDropdown
                  style={{ zIndex: "70" }}
                  title={
                    <span
                      style={{
                        cursor: "pointer",
                        fontWeight: "500",
                        fontSize: "15px",
                        color: "#000000",
                      }}
                      className="d-flex align-items-center"
                    >
                      <span>Resources</span>
                      <FontAwesomeIcon
                        className="socialmed2 -m-1"
                        icon={faCaretDown}
                        style={{
                          marginTop: "-10px",
                          marginLeft: "10px",
                          height: "12px",
                          display: "inline",
                        }}
                      />
                    </span>
                  }
                  id="basic-nav-dropdown"
                  className="ms-5 text-black my-auto nav-link2 mr-auto no-arrow"
                >
                  <NavDropdown.Item
                    style={{ fontWeight: "500" }}
                    onClick={toBlog}
                  >
                    Blog
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    style={{ fontWeight: "500" }}
                    onClick={toWebinar}
                  >
                    Events
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    style={{ fontWeight: "500" }}
                    onClick={toScholarship}
                  >
                    Scholarship
                  </NavDropdown.Item>

                  {/* <NavDropdown.Item
                                        style={{ fontWeight: "500" }}
                                        onClick={toLoans}
                                      >
                                        Loans
                                      </NavDropdown.Item> */}
                </NavDropdown>

                <div className=" my-auto d-none d-lg-block  lg:ml-auto xl:ml-auto  w-[300px] xl:w-[380px]  ">
                  <SearchComponent />
                </div>

                {authUser ? (
                  <div
                    ref={profileRefSecond}
                    id="prrrofile"
                    className="relative"
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      marginLeft: "10px",
                    }}
                  >
                    {/* Profile Icon */}
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowcatalogboxSecond((prev) => !prev);
                      }}
                      className="text-center cursor-pointer sm:hidden" //still on it
                      style={{
                        marginTop: "5px",
                        width: "40px",
                        height: "40px",
                        borderRadius: "100px",
                        backgroundColor: "#156614",
                        animation: "glow 1s infinite",
                      }}
                    >
                      <h5 style={{ color: "#ffffff", paddingTop: "30%" }}>
                        {fullnameprefix}
                      </h5>
                    </div>
                    {/* Dropdown Menu */}
                    {showcatalogboxSecond && (
                      <div
                        className="sm:hidden absolute bg-[#e3f8e7] border border-[#95beb5] rounded-xl p-3 shadow-md z-50"
                        style={{
                          top: "120%",
                          right: "0",
                          width: "240px",
                          transition: "all 0.3s ease",
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="text-center">
                          <div
                            className="mx-auto flex items-center justify-center mb-2"
                            style={{
                              width: "50px",
                              height: "50px",
                              borderRadius: "100px",
                              backgroundColor: "#156614",
                            }}
                          >
                            <h3 style={{ color: "#ffffff" }}>
                              {fullnameprefix}
                            </h3>
                          </div>
                          <p style={{ fontWeight: "bold", fontSize: "16px" }}>
                            {usersAvatar}
                          </p>
                          <p style={{ color: "#696969", fontSize: "13px" }}>
                            {fullnames}
                          </p>
                          <hr />
                        </div>

                        <div style={{ marginLeft: "15px" }}>
                          <p
                            className="nav-links"
                            onClick={toProfile}
                            style={{ cursor: "pointer" }}
                          >
                            My profile
                          </p>
                          <p
                            className="nav-links"
                            onClick={userSignOut}
                            style={{ cursor: "pointer" }}
                          >
                            Log out
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <>
                    <Button
                      className="ms-4 bg-transparent rounded-lg cursor-pointer mt-[5px] lg:my-auto xl:my-auto border-[#367E3E] p-1 text-[#367E3E] px-4 xl:text-nowrap login"
                      style={{
                        marginTop: "5px",
                        border: "1px solid #367E3E",
                        padding: "0px 16px",
                        color: "#367E3E",
                        whiteSpace: "nowrap",
                      }}
                      onClick={toSignin}
                    >
                      Log In
                    </Button>

                    <Button
                      className="ms-4 mr-lg-5 xl:text-nowrap  nav-links"
                      style={{
                        marginTop: "5px",
                        backgroundColor: "#367E3E",
                        fontSize: "16px",
                        marginRight: " 20px",
                        whiteSpace: "nowrap",
                      }}
                      variant="success"
                      onClick={toSignUp}
                    >
                      Join for Free
                    </Button>
                  </>
                )}
              </Nav>
            </Navbar.Collapse>

            {/* ===== SIDEBAR DRAWER ===== */}
            <div
              className={`fixed top-0 left-0 h-full w-[280px] bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out ${
                sidebarOpen ? "translate-x-0" : "-translate-x-full"
              }`}
              style={{ zIndex: 50 }}
            >
              {/* ==== SIDEBAR HEADER ==== */}
              <div className="p-4 flex justify-between items-center border-b">
                <img
                  src={
                    weAreInDecember
                      ? "../../images/new-logo.png"
                      : "../../images/doyenifyAcademy.png"
                  }
                  alt="Logo"
                  className="h-[35px] cursor-pointer"
                  onClick={navigatehome}
                />
                {/* <button onClick={closeSidebar}>
                  <FontAwesomeIcon icon={faTimes} size="lg" />
                </button> */}
              </div>

              <div className="p-4 overflow-y-auto h-[calc(100%-60px)]">
                {/* <Navbar.Collapse id="responsive-navbar-nav"  > */}
                {/* <Nav className="justify-content-end flex-grow-1 pe-3" > */}
                <Nav className="flex flex-col space-y-3">
                  <div
                    onMouseEnter={() => setShowcoursesboxSide(true)}
                    onMouseLeave={() => setShowcoursesboxSide(false)}
                  >
                    <div className="coursesNav" id="coursse">
                      <div
                        className="ms-5 text-black nav-links2"
                        onClick={showCousesList}
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Schools{" "}
                        <FontAwesomeIcon
                          className="socialmed2"
                          icon={faCaretDown}
                          style={{
                            marginLeft: "7px",
                            height: "12px",
                            display: "inline",
                            whiteSpace: "nowrap",
                          }}
                        />
                      </div>

                      <div
                        className={
                          showcoursesboxSide
                            ? "showprofilebox"
                            : "hideprofilebox"
                        }
                      >
                        <div className="coursescolorbox ">
                          <div>
                            <div className="container">
                              <div className="row coursetttab">
                                <div className="col-md-4">
                                  <h4 style={{ color: "#597771" }}>Schools</h4>
                                  <DropdownButton
                                    className="m-2 softwarelink"
                                    onClick={showSoftwareCourses}
                                    variant="default"
                                    id="dropdown-basic-button"
                                    title="Software Engineering"
                                    drop="end"
                                  >
                                    {activeDropdownId === "softwareLink" &&
                                      filteredCourses?.length > 0 && (
                                        <div className="max-h-48 overflow-y-auto">
                                          {filteredCourses?.map((item) => (
                                            <Dropdown.Item
                                              key={item.id}
                                              onClick={() =>
                                                getCourseListDetails(
                                                  item.CourseName,
                                                )
                                              }
                                            >
                                              {item.CourseName}
                                            </Dropdown.Item>
                                          ))}
                                        </div>
                                      )}
                                  </DropdownButton>

                                  <DropdownButton
                                    className="m-2 productdesignlink"
                                    onClick={showProductDesignCourses}
                                    variant="default"
                                    id="dropdown-basic-button"
                                    title="Product Design"
                                    drop="end"
                                  >
                                    {filteredCourses?.length > 0 ? (
                                      <div className="max-h-48 overflow-y-auto">
                                        {filteredCourses?.map((item) => (
                                          <Dropdown.Item
                                            key={item.id}
                                            onClick={() =>
                                              getCourseListDetails(
                                                item.CourseName,
                                              )
                                            }
                                          >
                                            {item.CourseName}
                                          </Dropdown.Item>
                                        ))}
                                      </div>
                                    ) : null}
                                  </DropdownButton>

                                  <DropdownButton
                                    className="m-2 datasciencelink"
                                    onClick={showDataScienceCourses}
                                    variant="default"
                                    id="dropdown-basic-button"
                                    title="Data Science"
                                    drop="end"
                                  >
                                    {filteredCourses?.length > 0 ? (
                                      <div className="max-h-48 overflow-y-auto">
                                        {filteredCourses?.map((item) => (
                                          <Dropdown.Item
                                            key={item.id}
                                            onClick={() =>
                                              getCourseListDetails(
                                                item.CourseName,
                                              )
                                            }
                                          >
                                            {item.CourseName}
                                          </Dropdown.Item>
                                        ))}
                                      </div>
                                    ) : null}
                                  </DropdownButton>

                                  <DropdownButton
                                    className="m-2 cybersecuritylink"
                                    onClick={showCyberSecurityCourses}
                                    variant="default"
                                    id="dropdown-basic-button"
                                    title="Cyber Security"
                                    drop="end"
                                  >
                                    {filteredCourses?.length > 0 ? (
                                      <div className="max-h-48 overflow-y-auto">
                                        {filteredCourses?.map((item) => (
                                          <Dropdown.Item
                                            key={item.id}
                                            onClick={() =>
                                              getCourseListDetails(
                                                item.CourseName,
                                              )
                                            }
                                          >
                                            {item.CourseName}
                                          </Dropdown.Item>
                                        ))}
                                      </div>
                                    ) : null}
                                  </DropdownButton>

                                  <DropdownButton
                                    className="m-2 marketinglink"
                                    onClick={showMarketingCourses}
                                    variant="default"
                                    id="dropdown-basic-button"
                                    title="Marketing"
                                    drop="end"
                                  >
                                    {filteredCourses?.length > 0 ? (
                                      <div className="max-h-48 overflow-y-auto">
                                        {filteredCourses?.map((item) => (
                                          <Dropdown.Item
                                            key={item.id}
                                            onClick={() =>
                                              getCourseListDetails(
                                                item.CourseName,
                                              )
                                            }
                                          >
                                            {item.CourseName}
                                          </Dropdown.Item>
                                        ))}
                                      </div>
                                    ) : null}
                                  </DropdownButton>

                                  <DropdownButton
                                    className="m-2 productmanagementlink"
                                    onClick={showProductManagementCourses}
                                    variant="default"
                                    id="dropdown-basic-button"
                                    title="Product Management"
                                    drop="end"
                                  >
                                    {filteredCourses?.length > 0 ? (
                                      <div className="max-h-48 overflow-y-auto">
                                        {filteredCourses?.map((item) => (
                                          <Dropdown.Item
                                            key={item.id}
                                            onClick={() =>
                                              getCourseListDetails(
                                                item.CourseName,
                                              )
                                            }
                                          >
                                            {item.CourseName}
                                          </Dropdown.Item>
                                        ))}
                                      </div>
                                    ) : null}
                                  </DropdownButton>

                                  <DropdownButton
                                    className="m-2 nocodelink"
                                    onClick={showNocodepathCourses}
                                    variant="default"
                                    id="dropdown-basic-button"
                                    title="No Code Path"
                                    drop="end"
                                  >
                                    {filteredCourses?.length > 0 ? (
                                      <div className="max-h-32 overflow-y-auto">
                                        {filteredCourses?.map((item) => (
                                          <Dropdown.Item
                                            key={item.id}
                                            onClick={() =>
                                              getCourseListDetails(
                                                item.CourseName,
                                              )
                                            }
                                          >
                                            {item.CourseName}
                                          </Dropdown.Item>
                                        ))}
                                      </div>
                                    ) : null}
                                  </DropdownButton>
                                </div>
                                <div className="col-md-8">
                                  <br />
                                  <h4>Our services</h4>
                                  <div
                                    className="row"
                                    style={{ marginTop: "15px" }}
                                  >
                                    <div className="col-md-6">
                                      <p
                                        className="nav-links23"
                                        onClick={toYungDoyen}
                                      >
                                        Yung Doyens
                                      </p>
                                    </div>
                                    <div className="col-md-6">
                                      <p
                                        className="nav-links23"
                                        onClick={toHandsonexperience}
                                      >
                                        Hands-on Experience
                                      </p>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-md-6">
                                      <p
                                        className="nav-links23"
                                        onClick={toInterviewprepcvreview}
                                      >
                                        Interview Prep/CV Review
                                      </p>
                                    </div>

                                    <div className="col-md-6">
                                      <p
                                        className="nav-links23"
                                        onClick={getajob}
                                      >
                                        Doyenify Talent
                                      </p>
                                    </div>
                                  </div>

                                  <div className="row">
                                    <div className="col-md-6">
                                      <p
                                        className="nav-links23"
                                        onClick={toDoyenaccess}
                                      >
                                        Doyen Access
                                      </p>
                                    </div>

                                    <div className="col-md-6">
                                      <p
                                        className="nav-links23"
                                        onClick={toBookConsultation}
                                      >
                                        Where do I begin?
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <p
                                      className="nav-links23"
                                      onClick={toDoyenifyJobs}
                                    >
                                      Jobs
                                    </p>
                                  </div>
                                  <hr />
                                  <div>
                                    <h4>Why learn at Doyenify Academy</h4>
                                    <p>
                                      We provide educational programs crafted by
                                      experts with deep industry knowledge and
                                      co-created with leading companies.
                                    </p>

                                    {authUser ? (
                                      <></>
                                    ) : (
                                      <div style={{ display: "inline" }}>
                                        <button
                                          className="btn joinforbtn"
                                          onClick={toSignUp}
                                        >
                                          Join for Free
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                  <div style={{ marginTop: "11px" }}>
                                    <Faqcontainer />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Nav.Link
                    href="#howitwork"
                    className="ms-5 text-black nav-links2"
                    onClick={navigatehome}
                    style={{ whiteSpace: "nowrap" }}
                  >
                    How it works{" "}
                  </Nav.Link>

                  <NavDropdown
                    style={{ zIndex: "70" }}
                    title={
                      <span
                        style={{
                          cursor: "pointer",
                          fontWeight: "500",
                          fontSize: "15px",
                          color: "#000000",
                        }}
                        className="d-flex align-items-center"
                      >
                        <span>Resources</span>
                        <FontAwesomeIcon
                          className="socialmed2 -m-1"
                          icon={faCaretDown}
                          style={{
                            marginTop: "-10px",
                            marginLeft: "10px",
                            height: "12px",
                            display: "inline",
                          }}
                        />
                      </span>
                    }
                    id="basic-nav-dropdown"
                    className="ms-5 text-black my-auto nav-link2 mr-auto no-arrow"
                  >
                    <NavDropdown.Item
                      style={{ fontWeight: "500" }}
                      onClick={toBlog}
                    >
                      Blog
                    </NavDropdown.Item>

                    <NavDropdown.Item
                      style={{ fontWeight: "500" }}
                      onClick={toWebinar}
                    >
                      Events
                    </NavDropdown.Item>

                    <NavDropdown.Item
                      style={{ fontWeight: "500" }}
                      onClick={toScholarship}
                    >
                      Scholarship
                    </NavDropdown.Item>

                    {/* <NavDropdown.Item
                    style={{ fontWeight: "500" }}
                    onClick={toLoans}
                  >
                    Loans
                  </NavDropdown.Item> */}
                  </NavDropdown>

                  <div className=" ml-8 my-auto d-none d-lg-block w-[300px] xl:w-[380px] ">
                    <SearchComponent />
                  </div>

                  {authUser ? (
                    <div
                      ref={profileRefThird}
                      id="prrrofile"
                      className="relative"
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        marginLeft: "10px",
                      }}
                    >
                      {/* Profile Icon */}
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowcatalogboxThird((prev) => !prev);
                        }}
                        className="text-center cursor-pointer sm:hidden" //still on it
                        style={{
                          marginTop: "5px",
                          width: "40px",
                          height: "40px",
                          borderRadius: "100px",
                          backgroundColor: "#156614",
                          animation: "glow 1s infinite",
                        }}
                      >
                        <h5 style={{ color: "#ffffff", paddingTop: "30%" }}>
                          {fullnameprefix}
                        </h5>
                      </div>
                      {/* Dropdown Menu */}
                      {showcatalogboxThird && (
                        <div
                          className="sm:hidden absolute bg-[#e3f8e7] border border-[#95beb5] rounded-xl p-3 shadow-md z-50"
                          style={{
                            top: "120%",
                            right: "0",
                            width: "240px",
                            transition: "all 0.3s ease",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="text-center">
                            <div
                              className="mx-auto flex items-center justify-center mb-2"
                              style={{
                                width: "50px",
                                height: "50px",
                                borderRadius: "100px",
                                backgroundColor: "#156614",
                              }}
                            >
                              <h3 style={{ color: "#ffffff" }}>
                                {fullnameprefix}
                              </h3>
                            </div>
                            <p style={{ fontWeight: "bold", fontSize: "16px" }}>
                              {usersAvatar}
                            </p>
                            <p style={{ color: "#696969", fontSize: "13px" }}>
                              {fullnames}
                            </p>
                            <hr />
                          </div>

                          <div style={{ marginLeft: "15px" }}>
                            <p
                              className="nav-links"
                              onClick={toProfile}
                              style={{ cursor: "pointer" }}
                            >
                              My profile
                            </p>
                            <p
                              className="nav-links"
                              onClick={userSignOut}
                              style={{ cursor: "pointer" }}
                            >
                              Log out
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <>
                      <Button
                        className="ms-4 bg-transparent rounded-lg cursor-pointer mt-[5px] lg:my-auto xl:my-auto border-[#367E3E] p-1 text-[#367E3E] px-4 xl:text-nowrap login"
                        style={{
                          marginTop: "5px",
                          border: "1px solid #367E3E",
                          padding: "0px 16px",
                          color: "#367E3E",
                          whiteSpace: "nowrap",
                        }}
                        onClick={toSignin}
                      >
                        Log In
                      </Button>

                      <Button
                        className="ms-4 mr-lg-5 xl:text-nowrap  nav-links"
                        style={{
                          marginTop: "5px",
                          backgroundColor: "#367E3E",
                          fontSize: "16px",
                          marginRight: " 20px",
                          whiteSpace: "nowrap",
                        }}
                        variant="success"
                        onClick={toSignUp}
                      >
                        Join for Free
                      </Button>
                    </>
                  )}
                </Nav>
                {/* </Navbar.Collapse> */}
              </div>
            </div>
          </div>

          {/* ===== OVERLAY ===== */}
          {sidebarOpen && (
            <div
              className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40"
              onClick={closeSidebar}
            ></div>
          )}
        </Navbar>

        {/* { showSearch &&
              
              <div className="z-[999]  ms-0 w-full relative bg-black -mt-8">
            <div ref={searchRef} className="absolute ms-0  left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2   w-[70%] " >
              <SearchComponent  closeSearch={handleCloseSearch}/>            
              </div>   
              </div>               
              
            } */}

        {/* ==== MOBILE SEARCH OVERLAY ==== */}
        {showSearch && (
          <div className="z-[999] ms-0 w-full relative bg-black -mt-8">
            <div
              ref={searchRef}
              className="absolute ms-0 left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[70%]"
            >
              <SearchComponent closeSearch={handleCloseSearch} />
            </div>
          </div>
        )}

        {!showSearch && (
          <div className="secondheaders  my-[13px]  ">
            <div className="">
              <div className="col-md-6 w-[100%] ml-[auto] headeradj">
                <div className="">
                  <div className="col ">
                    <div className="text-center">
                      <a
                        href="https://api.whatsapp.com/send?phone=37253873078"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src="../../images/whatsapp.png"
                          style={{
                            marginLeft: "66px",
                            height: "24px",
                            display: "inline",
                          }}
                          alt="whatsap"
                        />
                      </a>

                      <img
                        src="../../images/phone.png"
                        alt="phone"
                        style={{
                          marginLeft: "17px",
                          height: "24px",
                          display: "inline",
                        }}
                      />
                      <p
                        style={{
                          marginLeft: "7px",
                          display: "inline",
                          fontSize: "12px",
                          fontWeight: "600",
                          fontFamily: "calibri",
                        }}
                      >
                        +372 5670 4920
                      </p>
                      <p
                        style={{
                          marginLeft: "7px",
                          display: "inline",
                          fontSize: "12px",
                          fontWeight: "600",
                          fontFamily: "calibri",
                        }}
                      >
                        +372 5672 0386
                      </p>
                      <p
                        style={{
                          marginLeft: "7px",
                          display: "inline",
                          fontSize: "12px",
                          fontWeight: "600",
                          fontFamily: "calibri",
                        }}
                      >
                        +372 5387 3078
                      </p>
                      <p
                        style={{
                          marginLeft: "14px",
                          display: "inline",
                          fontSize: "12px",
                          fontWeight: "600",
                          fontFamily: "calibri",
                        }}
                      >
                        +2347088096585
                      </p>
                      {/* <img onClick={toGmailsite2} src="../../images/mail.png" className="firstheader" alt="phone" /> */}
                      <div style={{ display: "inline-block" }}>
                        <span className="socialmed" onClick={toGmailsite}>
                          <FontAwesomeIcon
                            className="socialmed2"
                            style={{
                              marginLeft: "30px",
                              height: "19px",
                              display: "inline",
                            }}
                            icon={faEnvelope}
                          />

                          <p
                            onClick={toGmailsite2}
                            style={{
                              marginLeft: "7px",
                              display: "inline",
                              fontSize: "12px",
                              fontWeight: "600",
                              cursor: "pointer",
                              fontFamily: "calibri",
                            }}
                          >
                            info@doyenify.com
                          </p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </header>
    </div>
  );
};

export default Header;

// const UpLoadToAgolia = async ()=>{
//     const { courses } = useCourses();
//     const AlgoliaAppId= process.env.REACT_APP_ALGOLIA_APP_ID!
//     const AlgoliaSearchKey= process.env.REACT_APP_ALGOLIA_ADMIN_KEY!

//     const searchClient = algoliasearch(AlgoliaAppId, AlgoliaSearchKey);
//     const index = searchClient.initIndex("Academy_Course_Search")

//     const filterCourse =( courses ?? []).filter((course)=>course.isArchive === false)
//     console.log(filterCourse)
//    const formatedCourses = (filterCourse).map((course)=>({
//       objectID:course.id,
//       title:course.CourseName,
//       description:course.CourseDescription,
//       category:course.Category,
//       image: course.CourseImage
//    }))

// await index.saveObjects(formatedCourses).then(()=>console.log("saved")).catch((error)=>console.log(error))

// }

const Hit: React.FC<{ hit: any }> = ({ hit }) => {
  return (
    <a
      className="no-underline text-grepxen-600 "
      href={`/coursedetails/${hit.CourseName.toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")}`}
    >
      <article className="border flex flex-col items-center justify-center gap-2 mx-10 w-[270px]  h-[220px] rounded-xl p-2 shadow-md bg-white">
        <img src={hit.CourseImage} alt="courseimage" />
        <h2 className="text-sm  text-[#000000] font-bold">{hit.CourseName}</h2>
      </article>
    </a>
  );
};

const SearchComponent: React.FC<{ closeSearch?: () => void }> = ({
  closeSearch,
}) => {
  const [query, setQuery] = useState<string>("");
  const { courses } = useCourses();
  const filterCourse = (courses ?? []).filter(
    (course) => course.isArchive === false,
  );
  const filteredCourses = filterCourse.filter((course) =>
    course.CourseName.toLowerCase().includes(query.toLowerCase()),
  );

  const closeRefine = () => {
    if (closeSearch) {
      setQuery("");
      closeSearch();
    }
  };

  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <div className=" ">
      <div className="relative flex items-center justify-center  ">
        <Search className="absolute left-3 text-gray-500" size={18} />
        <input
          ref={inputRef}
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search courses..."
          className="w-full pl-10 pr-10 py-1 border rounded-md focus:ring-2 focus:ring-[#0F7D1A] focus:outline-none"
        />
        {query && (
          <button
            onClick={closeSearch ? () => closeRefine() : () => setQuery("")}
            className="absolute right-3 text-gray-500 hover:text-gray-700"
          >
            <X size={18} />
          </button>
        )}
      </div>

      {query !== "" && (
        <div className="h-[100vh] w-full z-[999] flex flex-col backdrop-blur-md bg-[#FFFFFF70] items-center absolute text-center  top-[35px] lg:top-[75px] xl:top-[75px] right-0 left-0">
          <div className="w-full overflow-auto mb-20">
            <div className="flex flex-wrap justify-center items-center mx-auto w-full max-w-screen-lg px-4 py-6 gap-4">
              {filteredCourses.map((hit) => (
                <Hit key={hit.CourseName} hit={hit} />
              ))}
            </div>

            {/* <Pagination
              classNames={{
                root: "flex justify-center mx-8 mt-6", // Centers the pagination
                list: "flex space-x-2 bg-gray-100 p-2 rounded-lg shadow-md", // Makes it horizontal with spacing and background
                item: "px-3 py-2 rounded-md transition-all duration-200", // Adds padding and rounded corners
                selectedItem: "bg-blue-500 text-white font-bold", // Highlights the selected page
                link: "hover:bg-blue-300 hover:text-white px-3 py-2 rounded-md", // Adds hover effect
                disabledItem: "opacity-50 cursor-not-allowed", // Styles disabled buttons
              }}
            /> */}
          </div>
        </div>
      )}
    </div>
  );
};
